import React from 'react';
import Grid from '@material-ui/core/Grid';
import {useHistory } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    tittle:{
        marginTop:"0px",
        marginBottom: "5px",
        minWidth: "200px",
        minHeight:"20px", 
        fontWeight: 250
    }
}));

export default function Informacion (props){
    const classes = useStyles();
    return (
        <>
        {props.informacion ?
            <>
                <p className={classes.tittle}>
                    {props.informacion}
                </p>
            </>
        : 
        null }
        </>
    );
}

